import { constants } from './constants'
import { forms } from './forms'
import { step1 } from './pages/step1'
import { step2 } from './pages/step2'
import { step3 } from './pages/step3'
import { step4 } from './pages/step4'
import { step5 } from './pages/step5'
import { step6 } from './pages/step6'
import { step7 } from './pages/step7'

export const ptPT = {
  general: {
    yes: 'yes',
    no: 'no',
    pt: {
      yes: 'Sim',
      no: 'Não',
    },
    cancel: 'Cancelar',
    save: 'Guardar',
    nextAction: 'Avançar',
    continue: 'Continuar',
    update: 'Atualizar',
    search: 'Por favor clique na lupa para pesquisar o NIF.',
    errors: {
      unauthorized:
        'Não autorizado. O token de acesso está em falta ou é inválido.',
      default: 'Ocorreu um erro inesperado, Por favor tente novamente.',
      traceparent: 'Traceparent: %{traceparent}',
      fulfillNecessaryFields: 'Por favor preencha os campos necessários',
      entityNotFound: 'Não foram encontradas entidades para o NIF indicado',
      fiscalNumberInvalid: 'NIF inválido',
      serverError: 'Erro ao comunicar com o servidor.',
      download: 'Não foi possível fazer o download do documento.',
    },
    success: {
      emailSent: 'E-mail enviado com sucesso',
    },
    simulation: 'SIMULAÇÃO Nº',
    newSimulation: 'NOVA SIMULAÇÃO',
    simulationReport: 'DOCUMENTOS SIMULAÇÃO',
    infoChangedSimulationNumber:
      'Dado que foi disponibilizado o relatório de simulação e ocorreram alterações aos dados de risco, o novo n.º de simulação é: %{newSimulationNumber}.',
  },
  constants,
  table: {
    vatNumber: 'NIF',
    name: 'NOME',
    address: 'MORADA',
    birthday: 'DATA DE NASCIMENTO',
    phone: 'TELEFONE',
    species: 'ESPÉCIE',
    breed: 'RAÇA',
    pack: 'PACK',
    premium: 'PRÉMIO POR ANIMAL',
  },
  entity: {
    fullName: 'Nome Completo',
    phone: 'Telemóvel',
    email: 'E-mail',
  },
  forms: forms,
  pages: {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    step7,
  },
  addressSelectTable: {
    location: 'Localidade',
    address: 'Morada',
    search: 'Pesquisar',
    searchTitle:
      'Pode pesquisar ou selecionar a morada do cliente, clicando no respetivo nome que aparece na tabela.',
    searchEmpty:
      'Não foram encontradas moradas para o termo indicado. Por favor tente outro termo.',
    streetEmpty: 'Sem arruamento',
    disclaimerInfo:
      'Após a indicação do código postal, os dados das moradas são devolvidos pelos CTT.',
    disclaimerFont:
      'Fonte: CTT - Correios de Portugal, S.A. - Sociedade Aberta',
  },
}
